import { Component, OnInit } from '@angular/core';
import { TranslationService } from '../../services/translate-with-retry.service'; // Update the path to your service

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  stories: any;

  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.translationService.translateObjectWithRetry('pages.news.stories').subscribe((translation: any) => {
      if (translation && translation.length) {
        this.stories = translation.slice(0, 3);
      }
    });
  }
}
